export const IMAGE_SCENES = {
    scenes: [
        // Backgrounds
        {
            id: 'ego_stage',
            path: 'images/backgrounds/ego_stage.png',
            description: 'Ego Maniacs stage background',
            category: 'background',
            games: ['68016cb23f0914bff706b7ca'],
        },
        {
            id: 'meme_museum',
            path: 'images/backgrounds/meme_museum.png',
            description: 'Meme Mash museum background',
            category: 'background',
            games: ['67d1c7c8d303f4b1017260a4'],
        },
        {
            id: 'wtf_newsroom',
            path: 'images/backgrounds/wtf_newsroom.png',
            description: 'WTF Is Happening newsroom background',
            category: 'background',
            games: ['68eb1f40d63530c3bfd356e6'],
        },
        {
            id: 'sandwich_shop',
            path: 'images/backgrounds/sandwich_shop.png',
            description: 'Sandwich shop background',
            category: 'background',
            games: ['6701bc6c35797c2928318643'],
        },
        {
            id: 'operating_table',
            path: 'images/backgrounds/operating_table.png',
            description: 'Operating table background',
            category: 'background',
            games: ['6921e33b0eef394c89845fb8'],
        },
        {
            id: 'desert_sky',
            path: 'images/backgrounds/desert_sky.png',
            description: 'Desert sky background',
            category: 'background',
            games: ['693bad642f3a8ff742190144'],
        },
        {
            id: 'kitchen_grill',
            path: 'images/backgrounds/kitchen_grill.png',
            description: 'Kitchen grill background',
            category: 'background',
            games: ['6944abab5d2f2d3fde971460'],
        },
        {
            id: 'background_bad_bunnies',
            path: 'images/backgrounds/background_bad_bunnies.png',
            description: 'Bad Bunnies background',
            category: 'background',
            games: ['69ac5a4510c9adc947dc1981'],
        },
        {
            id: 'background_feed_the_farm',
            path: 'images/backgrounds/background_feed_the_farm.png',
            description: 'Feed The Farm background',
            category: 'background',
            games: ['69c55319c9763aa207ae0fb2'],
        },
        {
            id: 'background_okie_dokie',
            path: 'images/backgrounds/background_okie_dokie.png',
            description: 'Okie Dokie background',
            category: 'background',
            games: ['6a3349523db03ba5ecbf1db2'],
        },
        {
            id: 'background_wild_things',
            path: 'images/backgrounds/background_wild_things.png',
            description: 'Wild Things background',
            category: 'background',
            games: ['6a4443ab95150cffae4f482e'],
        },
        {
            id: 'background_wanted',
            path: 'images/backgrounds/background_wanted.png',
            description: 'Wanted background',
            category: 'background',
            games: ['6a4445679a8400bf1b9aae8d'],
        },
        // EgoManiacs specific scenes
        {
            id: 'curtain',
            path: 'images/scenes/curtain.png',
            description: 'Curtain to cover a stage',
            category: 'props',
            games: ['68016cb23f0914bff706b7ca'],
        },
        {
            id: 'poppyLectern',
            path: 'images/scenes/poppyLectern.png',
            description: 'Poppy lectern prop',
            category: 'poppy',
            games: ['68016cb23f0914bff706b7ca'],
        },
        // Finish Each Other's Sandwiches specific scenes
        {
            id: 'longSandwich',
            path: 'images/scenes/longSandwich.png',
            description: 'Long sandwich prop',
            category: 'props',
            games: ['6701bc6c35797c2928318643'],
        },
        {
            id: 'crystalBall',
            path: 'images/scenes/crystalBall.png',
            description: 'Crystal ball prop',
            category: 'props',
            games: ['6701bc6c35797c2928318643'],
        },
        // Bad Bunnies specific scenes
        {
            id: 'bunnyAngel',
            path: 'images/scenes/bunnyAngel.png',
            description: 'Bunny angel for ascension animation',
            category: 'props',
            games: ['69ac5a4510c9adc947dc1981'],
        },
    ],
};
//# sourceMappingURL=imageScenes.js.map